<pages-menu-item *ngIf="rootPage" [item]="rootPage" [level]="0"></pages-menu-item>
<pages-menu-item [item]="item" [level]="level" *ngFor="let item of items"></pages-menu-item>
